// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itacredspg-inline-1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.itacredspg-inline-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.itacredspg-inline-3 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.itacredspg-inline-4 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.itacredspg-inline-5 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.itacredspg-inline-6 {
  padding: 0;
  overflow-x: auto;
}

.itacredspg-inline-7 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

.itacredspg-inline-8 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

.itacredspg-inline-9 {
  font-weight: 600;
}

.itacredspg-inline-10 {
  font-size: 10px;
  color: #94a3b8;
}

.itacredspg-inline-11 {
  font-family: monospace;
  font-size: 11px;
}

.itacredspg-inline-12 {
  font-family: monospace;
  font-size: 11px;
}

.itacredspg-inline-13 {
  cursor: pointer;
  color: #6366f1;
}

.itacredspg-inline-14 {
  font-family: monospace;
  font-size: 11px;
}

.itacredspg-inline-15 {
  font-size: 11px;
}

.itacredspg-inline-16 {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.itacredspg-inline-17 {
  background: #f1f5f9;
  padding: 1px 6px;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 600;
}

.itacredspg-inline-18 {
  font-size: 9px;
  color: #94a3b8;
}

.itacredspg-inline-19 {
  color: #94a3b8;
  font-size: 10px;
}

.itacredspg-inline-20 {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.itacredspg-inline-21 {
  color: #94a3b8;
  font-size: 10px;
}

.itacredspg-inline-22 {
  background: #eef2ff;
  padding: 1px 6px;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 600;
  color: #4338ca;
}

.itacredspg-inline-23 {
  display: flex;
  gap: 6px;
}

.itacredspg-inline-24 {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #4f46e5;
  cursor: pointer;
}

.itacredspg-inline-25 {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #ef4444;
  cursor: pointer;
}

.itacredspg-inline-26 {
  margin-top: 16px;
}

.itacredspg-inline-27 {
  margin-top: 16px;
}

.itacredspg-dyn-1 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itacredspg-1-background);
  color: var(--itacredspg-1-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITACredsPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC","sourcesContent":[".itacredspg-inline-1 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.itacredspg-inline-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.itacredspg-inline-3 {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.itacredspg-inline-4 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.itacredspg-inline-5 {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itacredspg-inline-6 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.itacredspg-inline-7 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itacredspg-inline-8 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itacredspg-inline-9 {\n  font-weight: 600;\n}\n\n.itacredspg-inline-10 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.itacredspg-inline-11 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itacredspg-inline-12 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itacredspg-inline-13 {\n  cursor: pointer;\n  color: #6366f1;\n}\n\n.itacredspg-inline-14 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itacredspg-inline-15 {\n  font-size: 11px;\n}\n\n.itacredspg-inline-16 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.itacredspg-inline-17 {\n  background: #f1f5f9;\n  padding: 1px 6px;\n  border-radius: 6px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.itacredspg-inline-18 {\n  font-size: 9px;\n  color: #94a3b8;\n}\n\n.itacredspg-inline-19 {\n  color: #94a3b8;\n  font-size: 10px;\n}\n\n.itacredspg-inline-20 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.itacredspg-inline-21 {\n  color: #94a3b8;\n  font-size: 10px;\n}\n\n.itacredspg-inline-22 {\n  background: #eef2ff;\n  padding: 1px 6px;\n  border-radius: 6px;\n  font-size: 9px;\n  font-weight: 600;\n  color: #4338ca;\n}\n\n.itacredspg-inline-23 {\n  display: flex;\n  gap: 6px;\n}\n\n.itacredspg-inline-24 {\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #4f46e5;\n  cursor: pointer;\n}\n\n.itacredspg-inline-25 {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ef4444;\n  cursor: pointer;\n}\n\n.itacredspg-inline-26 {\n  margin-top: 16px;\n}\n\n.itacredspg-inline-27 {\n  margin-top: 16px;\n}\n\n.itacredspg-dyn-1 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itacredspg-1-background);\n  color: var(--itacredspg-1-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
